import "styled-components";
import defaultTheme from "./default-theme";
import ornamentTheme from "./ornament-theme";

const writerTheme = {
  ...ornamentTheme, //из-за этого не работало
  layout: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/scroll.png") no-repeat center center,
    url("${process.env.PUBLIC_URL}/assets/images/background/ink.png") no-repeat center center,
    url("${process.env.PUBLIC_URL}/assets/images/background/spots.png") no-repeat center center,
    #23160e;`,
  },
  header: {
    fontColor: "#ebe3d8",
    // backgroundColor: "#4f382a",
    background: `linear-gradient(to right, transparent, rgba(79,	56,	42), transparent)`,
  },
  footer: {
    fontColor: "#ddd5c2",
  },
};

export default writerTheme;
